import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex items-center justify-center p-10 text-gray-600 dark:text-slate-300 min-w-[200px] min-h-[200px]">
      <div className="w-10 h-10 border-4 border-gray-300 dark:border-slate-600 border-t-blue-500 dark:border-t-blue-400 rounded-full animate-spin mr-4" />
      <span className="text-lg font-medium">{message}</span>
    </div>
  );
};

export default LoadingSpinner;